import React from 'react';
import ReactDOM from 'react-dom';
import "@babel/polyfill";
import { BrowserRouter as Router } from 'react-router-dom'; 
import ScrollToTop from './HOC/ScrollToTop/ScrollToTop';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
        <Router>    
            <ScrollToTop>   
                <App />
            </ScrollToTop>
        </Router>,
    document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js